import React from "react";
import { Link } from "react-router-dom";
import { motion } from "framer-motion";
import { useI18n } from "../i18n";
import { useSeo } from "../hooks/useSeo";
import { pathFor } from "../config/site";
import { IMAGES } from "../data/structure";

export default function NotFound({ pageKey = "home" }) {
  const { lang, d } = useI18n();
  useSeo({
    pageKey,
    title: `404 | Independent JLo Tribute`,
    description: d.pages.notFound.body,
    noindex: true,
  });

  return (
    <section className="relative min-h-[70vh] flex items-center justify-center px-4 overflow-hidden">
      <img src={IMAGES.goldStreaks} alt="" aria-hidden="true" className="absolute inset-0 h-full w-full object-cover opacity-15" />
      <div className="absolute inset-0 bg-gradient-to-b from-jlo-bg/70 via-jlo-bg/85 to-jlo-bg" />
      <motion.div
        initial={{ opacity: 0, y: 24 }}
        animate={{ opacity: 1, y: 0 }}
        transition={{ duration: 0.7, ease: [0.22, 1, 0.36, 1] }}
        className="relative z-10 text-center max-w-lg"
        data-testid="not-found"
      >
        <p className="font-display text-8xl sm:text-9xl font-black gold-text leading-none">404</p>
        <div className="mx-auto mt-6 h-px w-24 gold-rule" />
        <h1 className="mt-6 font-display text-2xl sm:text-3xl font-semibold text-jlo-warm">{d.pages.notFound.heading}</h1>
        <p className="mt-4 text-jlo-warm/70">{d.pages.notFound.body}</p>
        <Link
          to={pathFor(lang, "home")}
          data-testid="notfound-home-link"
          className="focus-gold mt-9 inline-flex items-center gap-2 rounded-full bg-jlo-gold px-7 py-3.5 text-sm font-semibold text-jlo-bg hover:bg-jlo-warm transition-colors"
        >
          {d.pages.notFound.cta}
        </Link>
      </motion.div>
    </section>
  );
}
